import type { FC, PropsWithChildren } from 'react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

const CardsGroup: FC<PropsWithChildren> = ({ children, ...rest }) => {
  return (
    <ColumnTrack
      columns={1}
      overrides={{
        lg: 3,
      }}
      {...rest}
    >
      {children}
    </ColumnTrack>
  )
}

export default CardsGroup
